module.exports = __webpack_public_path__ + "img/2@3x.412014a8.png";